import { Tabpanel } from '@pelckmans/business-components/components/tabs';
import { useContext } from 'react';
import WordlistSearchInput from './WordlistSearchInput';
import WordlistSearchResults from './WordlistSearchResults';
import WordlistContext from './_contexts/WordlistContext';

export default function WordlistSearchTab() {
  const { searchTerm, setSearchTerm, searchResults, searchError } = useContext(WordlistContext);

  return (
    <Tabpanel tabId="search" className="wordlist__tab">
      <WordlistSearchInput searchTerm={searchTerm} onSearchTermChange={setSearchTerm} />
      <WordlistSearchResults searchTerm={searchTerm} error={searchError} results={searchResults} />
    </Tabpanel>
  );
}
